// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","row":"Modal_row__lRfC0","container":"Modal_container__Ha+Ky","button":"Modal_button__PTCbC","button_a":"Modal_button_a__XusFL"};